import { render, staticRenderFns } from "./Parcours.vue?vue&type=template&id=065fa438&scoped=true"
import script from "./Parcours.vue?vue&type=script&lang=js"
export * from "./Parcours.vue?vue&type=script&lang=js"
import style0 from "./Parcours.vue?vue&type=style&index=0&id=065fa438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065fa438",
  null
  
)

export default component.exports